export default [
  {
    id: 1,
    key: 'active',
    name: '激活数（含自然量）',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      }, {
        label: '>',
        value: '>'
      }, {
        label: '<=',
        value: '<='
      }, {
        label: '<',
        value: '<'
      }
    ],
    unit: '个',
    fixed: false
  },
  {
    id: 2,
    key: 'ranking',
    name: 'iOS榜单排行',
    value: '',
    field_type: 'string',
    expression: '>=',
    equalenums: [
      {
        label: '>=',
        value: '>='
      }, {
        label: '>',
        value: '>'
      }, {
        label: '<=',
        value: '<='
      }, {
        label: '<',
        value: '<'
      }
    ],
    unit: '位',
    fixed: false
  }
]
